import { findIndex } from "lodash";
//import sendxAPI from '../../../xAPI'

const templateState = {
  id: -1,
  type: null,
  held: false,
  inScene: true
};

export function BoxReducer(
  state = { boxes: [] },
  action
) {
  let currentBox;
  let protocolSection = state.protocolSection;

  if (action.payload === undefined) {
    return state;
  }

  if (
    action.type !== "CREATE_BOX" &&
    !action.type.includes("@redux")
  ) {
    if (action.payload.hasOwnProperty("id")) {
      if (
        state.protocolSection.scene.apparatus.hasOwnProperty("boxes")
      ) {
        currentBox =
          state.protocolSection.scene.apparatus.boxes[
            findIndex(state.protocolSection.scene.apparatus.boxes, {
              id: action.payload.id,
            })
          ];
      }
    }
  }

  switch (action.type) {
    case "CREATE_BOX":
      //Create new obj from template state
      let newObj = { ...templateState, ...action.payload.props };

      if (protocolSection.scene.apparatus.hasOwnProperty("boxes")) {
        protocolSection.scene.apparatus.boxes = [
          ...protocolSection.scene.apparatus.boxes,
          newObj,
        ];
      } else {
        protocolSection.scene.apparatus.boxes = [newObj];
      }

      return {
        ...state,
        ...{
          protocolSection: protocolSection,
        },
      };
      case 'SET_BOX_HELD':

      currentBox.held = action.payload.held
      protocolSection.scene.apparatus.boxes[findIndex(state.boxes, { id: action.payload.id })] = currentBox

      return { ...state, ...{
        protocolSection: protocolSection
      } }
      case "SET_BOX_CONTROLS_VISIBLE":
        // Make the current box controls visible
        let boxes = state.protocolSection.scene.apparatus.boxes;
        boxes.forEach(box => {
          box.controlsVisible = false;
        });
        protocolSection.scene.apparatus.boxes = boxes;

        currentBox.controlsVisible = action.payload.controlsVisible;
  
        protocolSection.scene.apparatus.boxes[findIndex(state.boxes, { id: action.payload.id })] = currentBox;
        return { ...state, ...{ protocolSection: protocolSection } };

   
      case "SET_BOX_IN_SCENE":
        //Payload = {inScene}
        currentBox.inScene = action.payload.inScene;
        protocolSection.scene.apparatus.boxes[findIndex(state.protocolSection.scene.apparatus.boxes, { id: action.payload.id })] = currentBox;
        return { ...state, ...{ protocolSection: protocolSection } };
        

    case "UNDO":
      //Payload = {lastState}

      if (action.payload.lastState !== null && protocolSection.scene.apparatus.hasOwnProperty('boxes')) {
        protocolSection.scene.apparatus.boxes =
          action.payload.lastState.scene.apparatus.boxes;

        return {
          ...state,
          ...{
            protocolSection: protocolSection,
          },
        };
      } else {
        return state;
      }

    default:
      return state;
  }
}
